import { useEffect, useState } from "react";
import useAxios from "../../../utils/useAxios";
import { Pageable, PageableDTO } from "../../../types/pageable";
import { URL } from "../../../libraries/http/url";
import { AxiosError, AxiosInstance } from "axios";
import { IGenericRequest } from "../helpers/genericRequestHelpers";
import { Predicates } from "../../../libraries/predicates/predicates";

type SearchParams = {
  search?: string;
  context?: number[];
  lastDays?: number;
  limit?: number;
  offset?: number;
  user?: number;
  status?: string | string[];
  requestor: string;
  corresponding_object_id?: string;
};

export type ArtworkSearchResponse =
  | PageableDTO<IGenericRequest[]>
  | IGenericRequest[];

class ArtworkGenericMapper {
  static pageableToModel(
    dto: ArtworkSearchResponse,
    offset?: number,
  ): Pageable<IGenericRequest> {
    return {
      total: Predicates.isPageable(dto) ? dto.count : 0,
      offset: offset ?? 0,
      data: Predicates.isPageable(dto) ? dto.results : dto,
    };
  }
}

type GenericRequestResponse = PageableDTO<IGenericRequest[]>;

export const fetchGenericRequest = async ({
  search,
  context,
  limit,
  user,
  status,
  requestor,
  axios,
  offset,
  lastDays,corresponding_object_id
}: SearchParams & { axios: AxiosInstance }): Promise<any> => {
  try {
    const searchParams = URL.createSearchParams({
      search,
      context,
      limit,
      user,
      status,
      lastDays,
      offset,
      requestor,corresponding_object_id
    });

    const response = await axios.get<GenericRequestResponse>(
      `/artwork-master/request/?${searchParams.toString()}`,
    );

    return response.data;
  } catch (err) {
    console.error(err);
    return;
  }
};

export default function useArtworkGenericRequest({
  search,
  context,
  limit,
  user,
  status,
  requestor,
  offset,
  lastDays,
                                                   corresponding_object_id
}: SearchParams) {
  const axios = useAxios();

  const [data, setData] = useState<{
    isLoading: boolean;
    data?: Pageable<any>;
  }>({ isLoading: false });

  useEffect(() => {
    const getData = async () => {
      try {
        setData({ isLoading: true });
        const response = await fetchGenericRequest({
          search,
          context,
          limit,
          user,
          status,
          requestor,
          lastDays,
          offset,
          axios,corresponding_object_id
        });

        setData({ isLoading: false, data: response });
      } catch (err) {
        if (
          !(err instanceof AxiosError && err.code === AxiosError.ERR_CANCELED)
        )
          setData({ isLoading: false });
      }
    };

    getData();
  }, [search, context, limit, user, status, requestor, lastDays,corresponding_object_id]);

  return data;
}
